import { getOptimizelyForcedVariation, getUserOptimizelyId } from "@/api/user"
import Vue from "vue"

const state = () => ({
  optimizelyId: null,
  optimizelyData: {
    trailer_video_enable: true,
  },
})

const getters = {
  optimizelyData: state => state.optimizelyData,
  optimizelyId: state => state.optimizelyId,
}

const mutations = {
  setOptimizelyId: (state, id) => (state.optimizelyId = id),
  setOptimizelyData: (state, data) => (state.optimizelyData = { ...data }),
}

const actions = {
  async loadOptimizelyId ({ commit, state }) {
    if (state.optimizelyId) {
      return
    }
    const optimizelyId = window.localStorage.getItem("optimizelyUserId")
    if (optimizelyId) {
      commit("setOptimizelyId", optimizelyId)
      return
    }
    const data = await getUserOptimizelyId()
    if (data?.optimizely_user_id) {
      window.localStorage.setItem("optimizelyUserId", data.optimizely_user_id)
      commit("setOptimizelyId", data.optimizely_user_id)
    }
  },
  trackEvent ({ state }, event) {
    try {
      if (Vue.prototype.$optimizely) {
        const optimizelyId = window.localStorage.getItem("optimizelyUserId")
        if (optimizelyId) {
          Vue.prototype.$optimizely.track(event, optimizelyId)
        } else if (state.optimizelyId) {
          Vue.prototype.$optimizely.track(event, state.optimizelyId)
        }
      }
    } catch (error) {
      console.error(error)
    }
  },
  async loadTest (
    { dispatch, state, commit },
    { experimentKey, featureKey, variables }
  ) {
    await dispatch("loadOptimizelyId")
    let optimizelyData = state.optimizelyData
    const result = await Vue.prototype.$optimizely.onReady()
    if (!result.success) return
    const featureEnabled = Vue.prototype.$optimizely.isFeatureEnabled(
      featureKey,
      state.optimizelyId
    )
    if (!featureEnabled) return
    // handle forced variation
    try {
      const data = await getOptimizelyForcedVariation({
        featureKey,
        optimizelyId: state.optimizelyId,
      })
      const variation =
        data.forced_variation && data.forced_variation.variation_key
          ? data.forced_variation.variation_key
          : null
      if (variation) {
        Vue.prototype.$optimizely.setForcedVariation(
          experimentKey,
          state.optimizelyId,
          variation
        )
      }
    } catch (error) {
      console.error(error)
    }
    // handle experiment variables
    for (let variable of variables) {
      optimizelyData[
        variable
      ] = await Vue.prototype.$optimizely.getFeatureVariableBoolean(
        featureKey,
        variable,
        state.optimizelyId
      )
    }
    commit("setOptimizelyData", optimizelyData)
  },
  async loadCoursePageTest ({ commit, dispatch, state }) {
    const experiment = "course_page_test"
    const feature = "course_page"

    let optimizelyData = state.optimizelyData
    await dispatch("loadOptimizelyId")

    const result = await Vue.prototype.$optimizely.onReady()
    if (result.success) {
      const featureEnabled = Vue.prototype.$optimizely.isFeatureEnabled(
        feature,
        state.optimizelyId
      )
      if (featureEnabled) {
        // set forced variation
        try {
          const data = await getOptimizelyForcedVariation({
            feature,
            optimizelyId: state.optimizelyId,
          })
          const variation =
            data.forced_variation && data.forced_variation.variation_key
              ? data.forced_variation.variation_key
              : null
          if (variation) {
            Vue.prototype.$optimizely.setForcedVariation(
              experiment,
              state.optimizelyId,
              variation
            )
          }
        } catch (error) {
          console.error(error)
        }
        optimizelyData.pay_to_unlock = await Vue.prototype.$optimizely.getFeatureVariableBoolean(
          feature,
          "pay_to_unlock",
          state.optimizelyId
        )
        commit("setOptimizelyData", optimizelyData)
      }
    }
  },
  async loadPgCreditsTest ({ commit, dispatch, state }) {
    const experiment = "pg_credits_test"
    const feature = "pg_credits"

    let optimizelyData = state.optimizelyData
    await dispatch("loadOptimizelyId")

    const result = await Vue.prototype.$optimizely.onReady()
    if (result.success) {
      const featureEnabled = Vue.prototype.$optimizely.isFeatureEnabled(
        feature,
        state.optimizelyId
      )
      if (featureEnabled) {
        // set forced variation
        try {
          const data = await getOptimizelyForcedVariation({
            feature,
            optimizelyId: state.optimizelyId,
          })
          const variation =
            data.forced_variation && data.forced_variation.variation_key
              ? data.forced_variation.variation_key
              : null
          if (variation) {
            Vue.prototype.$optimizely.setForcedVariation(
              experiment,
              state.optimizelyId,
              variation
            )
          }
        } catch (error) {
          console.error(error)
        }
        optimizelyData.showCredits = await Vue.prototype.$optimizely.getFeatureVariableBoolean(
          feature,
          "showCredits",
          state.optimizelyId
        )
        commit("setOptimizelyData", optimizelyData)
        const event = new CustomEvent("showCreditsEvent", {
          detail: {
            showCredits: optimizelyData.showCredits,
          },
        })
        document.dispatchEvent(event)
      }
    }
  },
  async loadCoachingLandingTest ({ dispatch }) {
    await dispatch("loadTest", {
      experimentKey: "coaching_landing_feature_test",
      featureKey: "coaching_landing_feature",
      variables: ["showTestimonials"],
    })
  },
  async loadBootcampEnrollTest ({ dispatch }) {
    await dispatch("loadTest", {
      experimentKey: "bootcamp_enroll_test",
      featureKey: "bootcamp_enroll",
      variables: ["trailer_video_enable"],
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/optimizely/optimizely.module.js